import React, { useState, useEffect } from 'react';
import { Gallery } from 'react-grid-gallery';
import styles from './Menu.module.css';
import { Link } from 'react-router-dom';
import type { ChangeEvent } from 'react';
import type { Donut, ItemProps } from '../assets/types';

type TGallery = Array<{
  src: string
  width: number
  height: number
  thumbnailCaption: string
  isSelected: boolean
}>;

interface TCart {
  id: number
  name: string
  price: number
}

let cart: Array<{
  id: number
  name: string
  price: number
}> = [];

const callStock = async (): Promise<any> => {
  const response = await fetch('https://soarin-donuts-backend.fly.dev/stocks');
  const data = await response.json();

  if (response.status === 404) {
    throw new Error('Status 404 received');
  }
  return data;
};

const postStock = async (): Promise<any> => {
  const requestOptions = {
    method: 'POST'
  };
  const response = await fetch('https://soarin-donuts-backend.fly.dev/create-stocks', requestOptions);
  // const data = await response.json();

  if (response.status === 404) {
    throw new Error('Status 404 received');
  }
  // if (response.status === 200) {
  //   throw new Error('Drone not docked');
  // }
  console.log('data: ', response);
  return response.status;
};

const putStock = async (name: string, inStock: boolean): Promise<any> => {
  const data = {
    name: name,
    in_stock: inStock
  };

  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  };
  const response = await fetch('https://soarin-donuts-backend.fly.dev/update-stock', requestOptions);
  // const data = await response.json();

  if (response.status === 404) {
    throw new Error('Status 404 received');
  }
  // if (response.status === 200) {
  //   throw new Error('Drone not docked');
  // }
  console.log('data: ', response);
  return response;
};

const updateStock = (): void => {
  console.log(s);
  async function updateS(): Promise<any> {
    const updatedArray = await Promise.all(
      s.map(async (item: Stock) => {
        await putStock(item.name, item.in_stock);
        return item;
      })
    );
    return updatedArray;
  }

  updateS()
    .then((data) => {
      console.log('updated all');
    })
    .catch((error) => {
      console.error(error);
    });
}

interface Stock {
  _id: string
  name: string
  in_stock: boolean
}
let s: Stock[] = [];

function initStock(): void {
  s = [];
  callStock()
    .then(data => {
      for (let i = 0; i < data.length; i++) {
        s.push(data[i]);
        if (data[i].in_stock === true) {
          cart.push({
            id: cart.length,
            name: data[i].name,
            price: 0
          })
        }
      }
    })
    .catch(error => {
      console.error(error);
    })
}
initStock();

function logStock(): void {
  callStock()
    .then(data => {
      console.log(data);
    })
    .catch(error => {
      console.error(error);
    });
}

// logStock();

const handleCount = (event: ChangeEvent<HTMLInputElement>): void => {
  const i: number = cart.findIndex(e => e.name === event.target.id);
  cart[i].price = event.target.valueAsNumber * 2;
}

function Item({
  id,
  name
}: TCart): JSX.Element {
  return (
    <li
      key={id}
    >
        <p>{name}  </p>
    </li>
  );
}

function StockMenu(): JSX.Element {
  const [t, sett] = useState<TGallery>([]);
  const [donuts, setDonuts] = useState<Donut[]>([]);

  const fetchMenu = async (): Promise<void> => {
    const response = await fetch('https://soarin-donuts-backend.fly.dev/api/donuts');
    const data = await response.json();
    if (response.status === 404) {
      throw new Error('Status 404 received');
    }
    console.log('data', data);
    setDonuts(data);
    sett(data?.map((donut: Donut) => {
      const picPath: string = (donut?.picture) ?? 'glazed_donut';
      const name: string = (donut?.name) ?? 'glazed donut';
      const price: string = String(donut?.price) ?? '1.99';
      return {
        src: `images/${picPath}.jpg`,
        width: 23,
        height: 23,
        thumbnailCaption: `${name}`,
        isSelected: false
      }
    }))
  };

  useEffect(() => {
    void fetchMenu();
  }, [])

  const handleSelect: (index: number) => void = (index: number) => {
    const nextImages = t.map((image, i) =>
      i === index ? { ...image, isSelected: !image.isSelected } : image
    );

    // If it already exists in the cart, don't add it
    if (!t[index].isSelected && !cart.some(e => e.name === t[index].thumbnailCaption)) {
      cart.push({
        id: cart.length,
        name: t[index].thumbnailCaption,
        price: 2
      });
    }

    cart = t[index].isSelected ? cart.filter(({ name }) => name !== t[index].thumbnailCaption) : cart;

    // FIXME
    for (let i: number = 0; i < s.length; i++) {
      s[i].in_stock = cart.some(e => e.name === s[i].name);
    }

    sett(nextImages);
  };

  // FIXME
  for (let i: number = 0; i < t.length; i++) {
    t[i].isSelected = cart.some(e => e.name === t[i].thumbnailCaption);
  }
  return (
    <div className={styles.container}>
      <div className={styles.cart}>
        <div>
          <button className={styles.placeorder} onClick={updateStock}>Update Stock</button>
          <p className={styles.header}>In Stock</p>
        </div>
        <div className={styles.cart2}>
          <ul role="list">
            {cart.map((item, index) =>
              <Item
                {...item}
              />
            )}
          </ul>
        </div>
      </div>
      <div className={styles.gallery1}>
        <h1 className={styles.header}>Soarin Donuts</h1>
        <div className={styles.gallery2}>
          <Gallery images={t} onSelect={handleSelect} />
        </div>
      </div>
    </div>
  );
}

export default StockMenu;
